import type { IItemsListBox } from "@app/dashboard/types/innerLayout/cards/items-list-box";
import { Card } from "../CardWrapper";
import { ItemsListing } from "./ItemsListing";

export const ItemsListBox = ({
  width,
  height,
  title,
  itemsList,
  localization
}: IItemsListBox) => {

  return (
    <Card
      width={width}
      height={height}
      title={title}
    >
      <ItemsListing
        itemsList={itemsList}
        localization={localization}
      />
    </Card>
  )
}